import React, { forwardRef, useImperativeHandle } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { Col, Form, Row } from 'reactstrap';
import OInput from '../../../Components/OElements/OInput';
import OSelect from '../../../Components/OElements/OSelect';
import { getDocumentTypeListQuery } from '../../../slices/thunks';

const AssociatedDocumentForm = forwardRef(({ onSubmit, dataToEdit, waterRightId }, ref) => {
	const dispatch = useDispatch();
	const isEditMode = !!dataToEdit;

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: dataToEdit?.name || '',
			water_right_id: waterRightId || dataToEdit?.water_right_id || '',
			document_type_id: dataToEdit?.document_type?._id || dataToEdit?.document_type_id || '',
			file: null,
		},
		validationSchema: Yup.object({
			name: Yup.string().required('El nombre del documento es requerido'),
			document_type_id: Yup.string().required('El tipo de documento es requerido'),
			file: isEditMode 
				? Yup.mixed().nullable()
				: Yup.mixed().required('El archivo es requerido'),
		}),
		onSubmit: values => {
			onSubmit(values);
		},
	});

	// Expose handleSubmit to parent via ref
	useImperativeHandle(ref, () => ({
		handleSubmit: () => {
			validation.handleSubmit();
		},
	}));

	return (
		<Form
			onSubmit={e => {
				e.preventDefault();
				validation.handleSubmit();
				return false;
			}}
		>
			<Row>
				{/* Hidden field for water_right_id */}
				<input
					type="hidden"
					name="water_right_id"
					value={validation.values.water_right_id}
				/>

				<Col lg={12} className='mb-3'>
					<OInput
						label="Nombre del Documento"
					name="name"
					type="text"
					placeholder="Ingrese el nombre del documento"
					validation={validation}
					></OInput>
				</Col>
				<Col lg={12} className='mb-3'>
					<OSelect
						label="Tipo de Documento"
						name="document_type_id"
						value={dataToEdit?.document_type?._id || dataToEdit?.document_type_id || validation.values.document_type_id}
						requestApi={async () => {
							const result = await dispatch(getDocumentTypeListQuery({
								filters: { disable: { $eq: false } },
								page: 1,
								limit: 1000,
							})).unwrap();
							return result.data || [];
						}}
						validation={validation}
						isRequired={true}
					/>
				</Col>

				{/* File input - only visible in CREATE mode */}
				{!isEditMode && (
					<Col lg={12} className='mb-3'>
						<div className="mb-3">
							<label htmlFor="file" className="form-label">
								Archivo <span className="text-danger">*</span>
							</label>
							<input
								id="file"
								name="file"
								type="file"
								className={`form-control ${validation.touched.file && validation.errors.file ? 'is-invalid' : ''}`}
								onChange={(event) => {
									validation.setFieldValue('file', event.currentTarget.files[0]);
								}}
								onBlur={() => validation.setFieldTouched('file', true)}
							/>
							{validation.touched.file && validation.errors.file && (
								<div className="invalid-feedback d-block">
									{validation.errors.file}
								</div>
							)}
						</div>
					</Col>
				)}
			</Row>
		</Form>
	);
});

AssociatedDocumentForm.displayName = 'AssociatedDocumentForm';

export default AssociatedDocumentForm;
